import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

// Lazy-loading komponentov pre lepší výkon
const LoginView = () => import('@/views/auth/LoginView.vue')
const ResetPasswordView = () => import('@/views/auth/ResetPasswordView.vue')
const DashboardView = () => import('@/views/DashboardView.vue')
const NovinkyView = () => import('@/views/novinky/NovinkyView.vue')
const UlohyView = () => import('@/views/ulohy/UlohyView.vue')
const UlohaDetailView = () => import('@/views/ulohy/UlohaDetailView.vue')
const SmenyView = () => import('@/views/smeny/SmenyView.vue')
const DochadzkaView = () => import('@/views/dochadzka/DochadzkaView.vue')
const DovolenkyView = () => import('@/views/dovolenky/DovolenkyView.vue')
const KontaktyView = () => import('@/views/kontakty/KontaktyView.vue')
const SmerniceView = () => import('@/views/smernice/SmerniceView.vue')
const PrikazyView = () => import('@/views/prikazy/PrikazyView.vue')
const PrikazyKonceptyView = () => import('@/views/prikazy/PrikazyKonceptyView.vue')
const PrikazKonceptDetailView = () => import('@/views/prikazy/PrikazKonceptDetailView.vue')
const PassMachineView = () => import('@/views/passmachine/PassMachineView.vue')
const TovaroznalectvoView = () => import('@/views/tovaroznalectvo/TovaroznalectvoView.vue')
const ReklamacieView = () => import('@/views/reklamacie/ReklamacieView.vue')
const ServisView = () => import('@/views/servis/ServisView.vue')
const PoziadavkyView = () => import('@/views/poziadavky/PoziadavkyView.vue')
const PoziadavkaDetailView = () => import('@/views/poziadavky/PoziadavkaDetailView.vue')
const MarketingView = () => import('@/views/marketing/MarketingView.vue')
const DokumentyView = () => import('@/views/dokumenty/DokumentyView.vue')
const KalendarView = () => import('@/views/kalendar/KalendarView.vue')
const FotkyView = () => import('@/views/fotky/FotkyView.vue')
const FeedbackView = () => import('@/views/feedback/FeedbackView.vue')
const ProfileView = () => import('@/views/profile/ProfileView.vue')
const SettingsView = () => import('@/views/settings/SettingsView.vue')
const ManualView = () => import('@/views/manual/ManualView.vue')
const ManualAdminView = () => import('@/views/manual/ManualAdminView.vue')
const NotFoundView = () => import('@/views/NotFoundView.vue')

// Admin views
const AdminUsersView = () => import('@/views/admin/UsersView.vue')
const AdminPredajneView = () => import('@/views/admin/PredajneView.vue')
const AdminSettingsView = () => import('@/views/admin/SettingsView.vue')
const AdminFeedbackView = () => import('@/views/admin/FeedbackView.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false, title: 'Prihlásenie' }
  },
  {
    // Odkaz z e-mailu "Zabudnuté heslo" (${FRONTEND_URL}/reset-password?token=...)
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView,
    meta: { requiresAuth: false, title: 'Obnovenie hesla' }
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true, title: 'Prehľad' }
  },
  {
    path: '/ulohy',
    name: 'ulohy',
    component: UlohyView,
    meta: { requiresAuth: true, title: 'Úlohy' }
  },
  {
    // Detail úlohy s diskusiou (odkaz zo zoznamu aj z e-mailov)
    path: '/ulohy/:id(\\d+)',
    name: 'uloha-detail',
    component: UlohaDetailView,
    meta: { requiresAuth: true, title: 'Detail úlohy' }
  },
  {
    path: '/novinky',
    name: 'novinky',
    component: NovinkyView,
    meta: { requiresAuth: true, title: 'Novinky' }
  },
  {
    path: '/novinky/:id',
    name: 'novinka-detail',
    component: NovinkyView,
    meta: { requiresAuth: true, title: 'Detail novinky' }
  },
  {
    path: '/smeny',
    name: 'smeny',
    component: SmenyView,
    meta: { requiresAuth: true, title: 'Moje smeny' }
  },
  {
    path: '/dochadzka',
    name: 'dochadzka',
    component: DochadzkaView,
    meta: { requiresAuth: true, title: 'Dochádzka' }
  },
  {
    path: '/dovolenky',
    name: 'dovolenky',
    component: DovolenkyView,
    meta: { requiresAuth: true, title: 'Dovolenky' }
  },
  {
    path: '/kontakty',
    name: 'kontakty',
    component: KontaktyView,
    meta: { requiresAuth: true, title: 'Kontakty' }
  },
  {
    path: '/smernice',
    name: 'smernice',
    component: SmerniceView,
    meta: { requiresAuth: true, title: 'Smernice' }
  },
  {
    path: '/prikazy',
    name: 'prikazy',
    component: PrikazyView,
    meta: { requiresAuth: true, title: 'Interné príkazy' }
  },
  {
    // Rozpracované interné príkazy na pripomienkovanie (vedenie a regionálny vedúci)
    path: '/prikazy/koncepty',
    name: 'prikazy-koncepty',
    component: PrikazyKonceptyView,
    meta: { requiresAuth: true, requiresDokumenty: true, title: 'Koncepty interných príkazov' }
  },
  {
    path: '/prikazy/koncepty/:id(\\d+)',
    name: 'prikaz-koncept-detail',
    component: PrikazKonceptDetailView,
    meta: { requiresAuth: true, requiresDokumenty: true, title: 'Koncept interného príkazu' }
  },
  {
    path: '/tovaroznalectvo',
    name: 'tovaroznalectvo',
    component: TovaroznalectvoView,
    meta: { requiresAuth: true, title: 'Tovaroznalectvo' }
  },
  {
    path: '/reklamacie',
    name: 'reklamacie',
    component: ReklamacieView,
    meta: { requiresAuth: true, title: 'Reklamácie' }
  },
  {
    path: '/servis',
    name: 'servis',
    component: ServisView,
    meta: { requiresAuth: true, title: 'Servis' }
  },
  {
    path: '/poziadavky',
    name: 'poziadavky',
    component: PoziadavkyView,
    meta: { requiresAuth: true, title: 'Poziadavky' }
  },
  {
    // Detail požiadavky s diskusiou (odkaz zo zoznamu aj z e-mailov)
    path: '/poziadavky/:id(\\d+)',
    name: 'poziadavka-detail',
    component: PoziadavkaDetailView,
    meta: { requiresAuth: true, title: 'Detail požiadavky' }
  },
  {
    path: '/passmachine',
    name: 'passmachine',
    component: PassMachineView,
    meta: { requiresAuth: true, title: 'BonusCard' }
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: MarketingView,
    meta: { requiresAuth: true, title: 'Aktuálne akcie' }
  },
  {
    path: '/dokumenty',
    name: 'dokumenty',
    component: DokumentyView,
    meta: { requiresAuth: true, title: 'Dokumenty' }
  },
  {
    path: '/kalendar',
    name: 'kalendar',
    component: KalendarView,
    meta: { requiresAuth: true, title: 'Kalendár' }
  },
  {
    path: '/fotky',
    name: 'fotky',
    component: FotkyView,
    meta: { requiresAuth: true, title: 'Fotky predajne' }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: FeedbackView,
    meta: { requiresAuth: true, title: 'Nápady a podnety' }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: { requiresAuth: true, title: 'Môj profil' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true, title: 'Nastavenia' }
  },
  // Admin routes
  {
    path: '/admin/users',
    name: 'admin-users',
    component: AdminUsersView,
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Správa používateľov' }
  },
  {
    path: '/admin/predajne',
    name: 'admin-predajne',
    component: AdminPredajneView,
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Správa predajní' }
  },
  {
    path: '/admin/settings',
    name: 'admin-settings',
    component: AdminSettingsView,
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Nastavenia systému' }
  },
  {
    path: '/admin/feedback',
    name: 'admin-feedback',
    component: AdminFeedbackView,
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Feedback' }
  },
  {
    path: '/statistiky',
    name: 'statistiky',
    component: () => import('@/views/statistiky/StatistikyView.vue'),
    // Štatistiky vidí admin aj vedenie (backend: roleMiddleware(['admin', 'manazment']))
    meta: { requiresAuth: true, requiresManager: true, title: 'Štatistiky a Analytics' }
  },
  {
    path: '/manual',
    name: 'manual',
    component: ManualView,
    meta: { requiresAuth: true, title: 'Manuál' }
  },
  {
    path: '/manual/admin',
    name: 'manual-admin',
    component: ManualAdminView,
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Správa manuálu' }
  },
  // 404 route
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFoundView,
    meta: { title: 'Stránka nenájdená' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Navigation guard pre kontrolu autentifikácie
router.beforeEach(async (to, from, next) => {
  // Nastavenie titulku stránky
  document.title = to.meta.title ? `${to.meta.title} | MANIA INTRANET` : 'MANIA INTRANET'
  
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const requiresManager = to.matched.some(record => record.meta.requiresManager)

  // Ak máme token, ale ešte nie používateľa (napr. po obnovení stránky), overíme ho pri každej route -
  // aj pri /login, aby prihláseného používateľa presmerovalo preč z prihlasovacieho formulára
  if (!authStore.isAuthenticated && authStore.token) {
    try {
      await authStore.checkAuth()
    } catch (error) {
      // Ak checkAuth zlyhalo, pokračujeme s normálnou logikou
    }
  }
  
  // Kontrola, či je používateľ prihlásený a či má potrebné oprávnenia
  if (requiresAuth && !authStore.isAuthenticated) {
    // Uloženie pôvodnej cesty pre presmerovanie po prihlásení.
    // Aj pri prvom otvorení (napr. odkaz z e-mailu na konkrétnu úlohu) sa po prihlásení vráti na pôvodnú adresu
    const redirectQuery = to.fullPath !== '/' ? { redirect: to.fullPath } : {}
    next({ name: 'login', query: redirectQuery })
  } else if (requiresAdmin && authStore.user?.rola !== 'admin') {
    // Používateľ nemá admin oprávnenia
    next({ name: 'dashboard' })
  } else if (requiresManager && !authStore.isManager) {
    // Len admin alebo vedenie
    next({ name: 'dashboard' })
  } else if (to.matched.some(record => record.meta.requiresDokumenty) && !authStore.mozeNahravatDokumenty) {
    // Koncepty interných príkazov - len tí, čo príkazy spravujú
    next({ name: 'prikazy' })
  } else if (to.name === 'login' && authStore.isAuthenticated) {
    // Používateľ je už prihlásený, presmerovanie na dashboard alebo redirect
    const redirectPath = to.query.redirect || '/'
    next(redirectPath)
  } else {
    next()
  }
})

export default router
